(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-split"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('contact-split')) {
    class ContactSplit extends HTMLElement {
      #abortController = new AbortController();

      connectedCallback() {
        const { signal } = this.#abortController;

        this.#preselect();
        this.addEventListener('change', this.#handleChange, { signal });
        document.addEventListener('shopify:block:select', this.#handleBlockSelect, { signal });
      }

      disconnectedCallback() {
        this.#abortController.abort();
      }

      get #inputs() {
        return Array.from(this.querySelectorAll('.contact-card__input'));
      }

      /** Selects a topic from ?thema=<kürzel> or from the form anchor Shopify adds after submit. */
      #preselect() {
        const url = new URL(window.location.href);
        const topic = url.searchParams.get('thema')?.toLowerCase();
        const formMatch = url.hash.match(/^#ContactForm-(.+)$/);

        const input = this.#inputs.find(
          (el) => (topic && el.dataset.topic === topic) || (formMatch && el.value === formMatch[1])
        );
        if (!input) return;

        input.checked = true;
        if (formMatch) {
          this.querySelector(`#ContactPanel-${input.value} .contact-split__notice`)?.focus();
        } else {
          this.#scrollToPanel(input.value);
        }
      }

      /** @param {Event} event */
      #handleChange = (event) => {
        const target = event.target;
        if (!(target instanceof HTMLInputElement) || !target.classList.contains('contact-card__input')) return;
        this.#scrollToPanel(target.value);
      };

      /** @param {Event & { detail?: { blockId?: string } }} event */
      #handleBlockSelect = (event) => {
        const input = this.#inputs.find((el) => el.value === event.detail?.blockId);
        if (input) input.checked = true;
      };

      /** @param {string} blockId */
      #scrollToPanel(blockId) {
        const panel = this.querySelector(`#ContactPanel-${blockId}`);
        if (!panel) return;

        requestAnimationFrame(() => {
          const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          panel.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
        });
      }
    }

    customElements.define('contact-split', ContactSplit);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
